module.exports = __webpack_public_path__ + "static/pourquoi-irriglobe-421a5c80d3267efce042eb47ac1aaf5d.mp4";